module.exports = __webpack_public_path__ + "static/media/white-wheel-icon-bottom.b5b1dc60.svg";